import { create } from 'zustand';
import { StoreApi, UseBoundStore } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { CanvasSlice, createCanvasSlice } from './canvas.slice';
import { MediaSlice, createMediaSlice } from './media.slice';
import { ProjectSlice, createProjectSlice } from './project.slice';
import { UiSlice, createUiSlice } from './ui.slice';

export type IViewerStore = MediaSlice & ProjectSlice & CanvasSlice & UiSlice;

export const useViewerStore = create<IViewerStore>()(
  devtools(
    immer((...args) => ({
      ...createMediaSlice(...args),
      ...createProjectSlice(...args),
      ...createUiSlice(...args),
      ...createCanvasSlice(...args),
    })),
    { name: 'Viewer | Viewer' }
  )
);

export type ProjectStoreInjector = UseBoundStore<StoreApi<IViewerStore>>;
